(async () => {

  if(!customElements.get('collection-description')) {

    class CollectionDescription extends HTMLElement {
      constructor() {
        super();

        this.collectionDescriptionGroup = this.querySelector('[data-collapsible-group]');
        this.collectionDescriptionTrigger = this.collectionDescriptionGroup.querySelector('[data-collapsible-trigger]');

        // Scroll to top of description
        this.collectionDescriptionTrigger?.addEventListener("click", function() {
          _scrollTo('.collection-information', -100);

        });

        function _scrollTo(selector, yOffset = -100){
          const el = document.querySelector(selector);
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({top: y, behavior: 'smooth'});
        }

      }
    }
    customElements.define('collection-description', CollectionDescription);
  }

})();